var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4 pb-2"},[_c('v-container',{staticClass:"pa-0 px-1",attrs:{"grid-list-xl":"","fluid":""}},[_c('iframe',{attrs:{"width":"100%","height":"600","src":_vm.iframeURL,"frameborder":"0","allowFullScreen":"true"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }